module.exports = __webpack_public_path__ + "static/img/icon_georgia.7984e115.png";